import * as constants from '../constants/actions';


/******************************
*******  Synchronous  *********
******************************/

export function authSave(token, tokenExpiry) {
  return {
    type: constants.AUTH_SAVE,
    token,
    tokenExpiry
  };
}

// Exists outside auth reducer in root reducer
export function authClear() {
	return {
		type: constants.AUTH_CLEAR
	}
}


/******************************
*******  Asynchronous  ********
******************************/


export async function fetchAppCredentials(email, signal) {
  return async (dispatch, getState) => {

    let url = api.API_URL + endpoint.USERS_DD_AUTH + '?key=88mcWPze588Iu9ZQr0epOLIT&email=' + encodeURIComponent(email);
    return fetch(url, {
      method: 'get',
      headers: authReq(api.HEADERS),
      signal,
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function checkLocalAuth(signal = null) {
  return async (dispatch, getState) => {

    let url = api.API_URL + endpoint.USERS_LOCAL_AUTH;
    return fetch(url, {
      method: 'get',
      headers: authReq(api.HEADERS),
      signal,
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}